import { render, staticRenderFns } from "./editMachineTranslate.vue?vue&type=template&id=56dd4f95"
import script from "./editMachineTranslate.vue?vue&type=script&lang=js"
export * from "./editMachineTranslate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports